export default __webpack_public_path__ + "static/media/logo.85414a04.png";